import {account$} from "../../../../../../../emitters/account";
import {
  apiV2PayByLinkCustomers,
  apiV2PayByLinkDetails,
  apiV2PayByLinkGetLimits,
  apiInvoiceGetNextInvoiceNumber
} from "../../../../../../../api/merchant/payByLink";
import {apiV2AssetsAmountList} from "../../../../../../../api/merchant/assetsAmount";
import getTime from "mn-utils/time";

export default ({id}) => {
  const accountDefaultCurrency = account$.getValue().fiat_code;

  const reqParams = {limit: 1000};

  const getDefaultPbLDetails = id
    ? apiV2PayByLinkDetails({id})
        .then((pbLDetails) => {
          const {
            buyer_name: customer,
            expired_at: expirationDate,
            invoice_fiat_amount: amount,
            invoice_fiat_code: currency,
            invoice_number: invoice,
            files = [],
            ...rest
          } = pbLDetails;

          return {
            ...rest,

            files: files.map((el) => ({id: el.id, name: el.file_name})),

            customer,
            expirationDate,
            amount,
            currency,
            invoice
          }
        })
    : apiInvoiceGetNextInvoiceNumber()
        .then((res) => (res || {}).number)
        .then((invoiceNumber) => {
          return ({
            invoice: invoiceNumber,
            currency: accountDefaultCurrency,
            expirationDate: new Date(getTime() + 1000 * 60 * 60 * 24 * 7)
          });
        });

  const getCustomersList = apiV2PayByLinkCustomers(reqParams)
      .then((res) => (res || {}).list || []);

  const getAssetsParams = apiV2AssetsAmountList(reqParams)
      .then((res = {}) => {
        return (res.list || [])
            .filter((el) => !!el.fiat_code)
            .map(({fiat_code}) => fiat_code);
      }).then((list) => {
        if (!list.length) return {list: [], minAmounts: {}};

        return apiV2PayByLinkGetLimits({fiat_codes: list})
            .then((limits) => {
              return {list, limits};
            })
      });


  return Promise.all([
    getDefaultPbLDetails,
    getCustomersList,
    getAssetsParams
  ]).then((res) => {
    const [
      defaultData = {},
      customersList,
      assetsParams
    ] = res;

    if (!id) {
      const list = assetsParams.list;

      defaultData['currency'] = list.includes(accountDefaultCurrency)
        ? accountDefaultCurrency
        : list[0];
    }

    return ({
      customersList,
      assetsList: assetsParams.list,
      assetsLimits: assetsParams.limits,
      defaultData: defaultData
    })
  }).catch(console.log);
}


